import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router-dom';
import { Route } from '@folio/stripes/core';
import Settings from './settings';
import LibTranslationsRoute from './routes/LibTranslationsRoute';
import PermsTranslationsRoute from './routes/PermsTranslationsRoute';
import ImportTranslationsRoute from './routes/ImportTranslationsRoute';
import MultiEditRoute from './routes/MultiEditRoute';
import ExportTranslationsRoute from './routes/ExportTranslationsRoute';
import AppsTranslationRoute from './routes/AppsTranslationRoute';
import RoutesTabs from './routes/RoutesTabs';
import AppConfigListProvider from './Context/AppConfigList/AppConfigListProvider';
import AppsTranslationsProvider from './Context/AppsTranslations/AppsTranslationsProvider';
import CurrentLocaleProvider from './Context/CurrentLocale/CurrentLocaleProvider';
import css from './routes/style.css';

function index(props) {
  const {
    actAs,
    match: { path },
  } = props;

  if (actAs === 'settings') {
    return <Settings {...props} />;
  }

  return (
    <AppConfigListProvider>
      <AppsTranslationsProvider>
        <CurrentLocaleProvider>
            <div className={css.appContainer}>
              <RoutesTabs />
              <div className={css.mainContent}>
                <Switch>
                  <Redirect exact from={path} to={`${path}/libTranslations`} />
                  <Route
                    path={`${path}/libTranslations`}
                    exact
                    component={LibTranslationsRoute}
                  />
                  <Route
                    path={`${path}/stripesApps`}
                    exact
                    component={AppsTranslationRoute}
                  />
                  <Route
                    path={`${path}/permsNames`}
                    exact
                    component={PermsTranslationsRoute}
                  />
                  <Route
                    path={`${path}/edit-translations`}
                    exact
                    component={MultiEditRoute}
                  />
                  <Route
                    path={`${path}/export-translations`}
                    exact
                    component={ExportTranslationsRoute}
                  />
                  <Route
                    path={`${path}/import-translations`}
                    exact
                    component={ImportTranslationsRoute}
                  />
                </Switch>
              </div>
            </div>
        </CurrentLocaleProvider>
      </AppsTranslationsProvider>
    </AppConfigListProvider>
  );
}

index.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  actAs: PropTypes.string.isRequired,
};

export default index;
